import React, { Fragment, useEffect } from "react";
import RightCircleArrow from "../../../styles/img/right-circle-arrow.png";
import { UiCol, UiRowContainer } from "../grid-container/GridContainer";
import CirclePlusIcon from "../../../styles/img/svg/CirclePlusIcon";
import CircleYellowPlusIcon from "../../../styles/img/svg/CircleYellowPlusIcon";
import PropTypes from "prop-types";

export function UiContentWr(props) {
    return (
        <>
            <section className="sb-content-area mt-4" {...props} />
        </>
    );
}
export function UiTopInputWr(props) {
    return (
        <>
            <UiRowContainer>
                <UiCol lg="12">
                    <div className="sb-top-input-wr" {...props} />
                </UiCol>
            </UiRowContainer>
        </>
    );
}
export function UiTopInputHeading(props) {
    return (
        <>
            <div className="sb-top-input-wr__top-heading">
                <CirclePlusIcon />
                <h5>{props.heading}</h5>
            </div>
        </>
    );
}
export function UiTopCustomInputHeading(props) {
    return (
        <>
            <div className="sb-top-input-wr__top-heading">
                <CircleYellowPlusIcon />
                <h5>{props.heading}</h5>
            </div>
        </>
    );
}
export function UiTabContentWr(props) {
    return (
        <>
            <div className="sb-top-tab-area" {...props} />
        </>
    );
}

export function UiTabContent(props) {
    return (
        <>
            <div className="sb-top-tab-area__content" {...props} />
        </>
    );
}

export function UiContentCol(props) {
    return (
        <>
            <div className="sb-content-area__col" {...props} />
        </>
    );
}

export function UiContentPinkCol(props) {
    return (
        <>
            <div className={props.className}>
                <div className="sb-content-area__col sb-bg-pnk">
                    {props.children}
                </div>
            </div>
        </>
    );
}

export function UiContentBgRedCol(props) {
    return (
        <>
            <div className="sb-rd-inf-cont-wrapper">{props.children}</div>
        </>
    );
}

export function UiContentWheelCol(props) {
    return (
        <>
            <div className="sb-content-area__wheel-col" {...props} />
        </>
    );
}

export function UiContentColWithSlider(props) {
    return (
        <>
            <div className="sb-content-area__col-slider" {...props} />
        </>
    );
}
export function UiColTitleWr(props) {
    return (
        <>
            <div className="sb-content-title-wr" {...props} />
        </>
    );
}

export function UiColTitle(props) {
    return (
        <>
            <div className="sb-content-title-wr__title">
                <h3>{props.title}</h3>
                {props.subtitle && (
                    <div className="sb-content-title-wr__text">
                        {props.sold && <>
                            <span> {props.sold}</span>out of <span>{props.products}</span>
                            </> 
                        }
                        {props.sales && <span> {props.sales}</span>}
                        <span>{props.subtitle}</span>
                        {props.verifying && (
                            <span> {props.verifying} verifying</span>
                        )}
                    </div>
                )}
            </div>
        </>
    );
}
export function UiColTitleRenault(props) {
    return (
        <>
            <div className="sb-content-title-wr__title">
                <h3>{props.title}</h3>
                    <div className="sb-content-title-wr__text">
                        {props.amount && <span> {props.amount} out of </span>}
                        {props.products && <span> {props.products} products sold at target</span>}                                         
                    </div>
            </div>
        </>
    );
}

export function UiViewAll(props) {
    return (
        <>
            <div onClick={props.onClick} className="sb-content-col-view-all">
                <div className={props.className}>
                    <span>View all</span>
                    <img src={RightCircleArrow} />
                </div>
            </div>
        </>
    );
}
export function UiServiceStarPerformanceTrackerRow(props) {
    return (
        <>
            <div className="sb-sales-performance-tracker__row">
                <span>{props.label}</span>
            </div>
        </>
    );
}
UiTopInputHeading.propTypes = {
    heading: PropTypes.string,
};
UiColTitle.propTypes = {
    title: PropTypes.string,
    amount: PropTypes.any,
    sales: PropTypes.any,
};


UiViewAll.propTypes = {
    className: PropTypes.string,
    action: PropTypes.func,
};

UiServiceStarPerformanceTrackerRow.propTypes = {
    label: PropTypes.string,
};
